import { render } from "./PrintMedicalCertificate.vue?vue&type=template&id=2de57490&scoped=true"
import script from "./PrintMedicalCertificate.vue?vue&type=script&lang=js"
export * from "./PrintMedicalCertificate.vue?vue&type=script&lang=js"

import "./PrintMedicalCertificate.vue?vue&type=style&index=0&id=2de57490&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de57490"]])

export default __exports__